import React from 'react';
import PropTypes from 'prop-types';
import Image from 'components/image';
import cn from 'classnames';

const ImageBlock = ({
  className,
  imageClassName,
  image,
  caption,
  photographer,
}) => {
  return image ? (
    <div className={cn('image-block', className)}>
      <figure className="image-block__container">
        <Image
          {...image}
          className={cn('image-block__image', imageClassName)}
        />
        {(caption || photographer) && (
          <figcaption className="image-block__caption">
            {caption && (
              <span className="image-block__caption-text">{caption}</span>
            )}
            {photographer && (
              <span className="image-block__photographer">{photographer}</span>
            )}
          </figcaption>
        )}
      </figure>
    </div>
  ) : null;
};

ImageBlock.viewModelMeta = {
  className: 'ignore',
  imageClassName: 'ignore',
};

ImageBlock.propTypes = {
  className: PropTypes.string,
  imageClassName: PropTypes.string,
  image: PropTypes.exact(Image.propTypes).isRequired,
  caption: PropTypes.string,
  photographer: PropTypes.string,
};

export default ImageBlock;
